import { Shield } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export function PrivacyBanner() {
  return (
    <Alert variant="info" className="mb-6">
      <Shield className="h-4 w-4" />
      <AlertTitle>Privacy Protected</AlertTitle>
      <AlertDescription>
        All data is anonymized. Individual employee information is never visible. Metrics require a
        minimum of 25 participants.
      </AlertDescription>
    </Alert>
  );
}
